import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 1. 引入你需要的组件
import {
    Button,
    Swipe,
    SwipeItem,
    Card,
    Collapse,
    CollapseItem,
    Icon,
    DropdownMenu,
    DropdownItem,
    Tab,
    Tabs,
    NavBar,
    Badge,
    ActionSheet,
    Cell,
    CellGroup,
    Field,
    Picker,
    Toast,
    Dialog
} from 'vant';

// 2. 引入组件样式
import 'vant/lib/index.css';
import 'vant/es/toast/style';
import 'view-ui-plus/dist/styles/viewuiplus.css';

const app = createApp(App)

app.use(Button)
app.use(Swipe)
app.use(SwipeItem)
app.use(Card)
app.use(Collapse)
app.use(CollapseItem)
app.use(Icon)
app.use(DropdownMenu)
app.use(DropdownItem)
app.use(Tab)
app.use(Tabs)
app.use(NavBar)
app.use(Badge)
app.use(ActionSheet)
app.use(Cell)
app.use(CellGroup)
app.use(Field)
app.use(Picker)
app.use(Toast)
app.use(Dialog);

import VueClipboard from 'vue-clipboard2'
app.use(VueClipboard)

app.use(store).use(router).mount('#app')
